import React from 'react';
import { Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckIcon from '@mui/icons-material/Check';
import { SubscriptionFeatureLabel } from './SubscriptionFeatureLabel';

export interface CreatorSubscriptionFeatureListProps {
    features: string[];
    highlightColor?: string;
}

export function CreatorSubscriptionFeatureList({
    features,
    highlightColor = '#ffc965',
}: CreatorSubscriptionFeatureListProps) {
    if (!features.length) return null;

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {features.map(feature => (
                <Box
                    key={feature}
                    sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 2,
                        p: 2.5,
                        borderRadius: 3,
                        bgcolor: 'rgba(255,255,255,0.04)',
                        border: '1px solid rgba(255,255,255,0.06)',
                    }}>
                    <Box
                        sx={{
                            p: 1.25,
                            borderRadius: '50%',
                            bgcolor: 'rgba(255,255,255,0.06)',
                            flexShrink: 0,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}>
                        <CheckIcon sx={{ color: highlightColor, fontSize: 22 }} />
                    </Box>
                    <SubscriptionFeatureLabel
                        feature={feature}
                        color="rgba(255,255,255,0.88)"
                        titleFontSize={14}
                        detailFontSize={12}
                        sx={{ pt: 0.75, flex: 1, minWidth: 0 }}
                    />
                    <CheckCircleIcon sx={{ color: '#4caf50', fontSize: 20, mt: 1, flexShrink: 0, ml: 'auto' }} />
                </Box>
            ))}
        </Box>
    );
}
